//package imports
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Formik, useFormik } from 'formik';
import phoneLogo from "../../assests/images/phone.png";
import mailLogo from "../../assests/images/mail.png";


//componenet imports
import CustomTextField from "../../utils/resuableComponents/CustomTextfield";
import { CustomDropdown } from "../../utils/resuableComponents/CustomDropdown";
import { getStateList } from "../../services/apiServices/GetServices";
import { GetCityList,emailsupport } from "../../services/apiServices/PostServices";
import { getSupportDetails } from "../../services/apiServices/GetServices";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import Loader from "../loadingScreens/Loader";




const Support = () => {

    const history = useHistory();
    const [statesData, setStatesData] = useState([])
    const [stateId, setStateId] = useState("")
    // const [cityData, setCityData] = useState([])
    const [defaultState, setDefaultState] = useState("")
    const [supportData,setSupportData]=useState([])
    const [initialValues, setInitialValues] = useState({
        firstName: '',
        email: '',
        message: '',
        state: '',
        phoneNumber: ''
    });
    const [simpleModal,setSimpleModal]=useState(false)
    const [isLoader,setIsLoader]=useState(false)
    const closeSimpleModal = () => setSimpleModal(false)


    useEffect(() => {
        callStateslistApi()
        getSupportData()
    }, []);

    //function to call list api
    const callStateslistApi = async () => {
        try{
            const res = await getStateList("state/1")
            if (res?.success) {
                setStatesData(res?.data)
                setDefaultState(res?.data[1].name)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
        
    }

    const getSupportData = async () => {
        try{
            const res = await getSupportDetails("support")
            if (res?.success) {
                setSupportData(res?.data[0])
                
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
    }



    const {
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            checkbox: false,
        },
    });



    //..............handle onchange of the form field......................................................//


    const handleNameChange = event => {
        const newName = event;
        const cleanedValue = event.replace(/[^a-zA-Z\s]/g, '').trimStart();
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            firstName: cleanedValue,
        }));
    };

    const handleEmailChange = event => {
        const newEmail = event;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            email: newEmail,
        }));
    };

    const handleMessageChange = event => {
        let message = event;
         if(event.startsWith(" ")){
              message = ""
        }else{
            message= event
        }
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            message: message,
        }));
    };

    const handleStateChange = event => {
        const state = event.target.value;
        setStateId(event.target.value)
        // setCityData([])
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            state: state,
            city: ""
        }));
    };

    const handlePincodeChange = event => {
        let phoneNumber = event;

        // Update only the 'email' field in formik values
        if(phoneNumber.startsWith('0')){
             phoneNumber = ""
        }else{
            phoneNumber = phoneNumber
        }
        formik.setValues(prevValues => ({
            ...prevValues,
            phoneNumber: phoneNumber,
        }));
    };

    const handleContinueButton = () => {
        history.push("/customerPortal/myShares")
    }

    const validate = values => {
        const errors = {};
        // Validate email
        if (!values.firstName) {
            errors.firstName = 'Full Name Required';
        }if (values.firstName.length < 3) {
            errors.firstName = 'Please enter minimum three characters';
        }
         else if (!values.email) {
            errors.email = 'Email Required';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = 'Invalid email address';
        } else if (!values.state) {
            errors.state = 'State Required';
        } else if (!values.phoneNumber) {
            errors.phoneNumber = 'Pincode Required'
        }else if (values.phoneNumber.length != 10) {
            errors.phoneNumber = 'Invalid Number'
        }
        else if (!values.message ) {
            errors.message = 'Message Required'
        }
        else if ( values.message.length < 3  ) {
            errors.message = 'Please enter minimum three characters'
        }
        return errors;
    };

    //function to handle on click of space submit
    const handleKeyDown = (event) => {
        // Check if the pressed key is the space key and if the submit button is focused
        if (event.key === ' ' ||  event.key === 'Spacebar' || event.target.selectionStart === 0 ) {
            const submitButton = document.activeElement;
            if (submitButton && submitButton.type === 'submit') {
                // Prevent the default action (form submission) when the space key is pressed
                event.preventDefault();
            }
        }
    };

    const handleFormSubmission = async (values) => {
        setIsLoader(true)
        const reqbody = {
                name:values?.firstName,
                email:values?.email,
                state:values?.state?.name,
                city:"",
                mobile:values?.phoneNumber,
                message :values?.message       
        }

      try{
        const res = await emailsupport(`support`,reqbody)
        if(res?.success){
            // showToast(1,res?.message)
            handleSimpleModal();
        }else{
           // showToast(3,res?.message)
           console.log("res",res?.message)
        }
      }catch(error){
        console.log("error",error)
      }
        
    }


    const formik = useFormik({
        initialValues: initialValues,
        validate,
        onSubmit: values => {

            handleFormSubmission(values)
          
            // Handle form submission
            console.log(values);
            // history.push("/customerPortal/clientDashboard")
            // resetForm();
        },

    });

    const isFormFilled = () => {
        // Custom validation function to check if all required fields are filled
        return formik.values?.firstName !== '' && formik.values?.email != '' && formik.values.phoneNumber != '' && formik.values.state != '' && formik.values.message != ''
    };

    const handleSimpleModal = () => {
        if (isFormFilled()) {
            setSimpleModal(true);
        }
    };

    return (
        <div class="col-md-12 full-height">
            {isLoader ? <Loader/> : null}
            <h1 class="fs-4 w-100 border-bottom border-top mb-xxl-5 p-2">
               Support
            </h1>
            <div class="px-5 ms-xl-4 py-1">
            <h5 class="m-0">
            Contact support team for any of your queries.
            </h5>
            </div>
            <div class="d-flex container-fluid justify-content-around">
            <div className="col-lg-7 d-flex justify-content-center border shadow-lg p-3 mx-3 my-2">
                <form onKeyDown={handleKeyDown} onSubmit={formik.handleSubmit} autoComplete="off">
                    <div class="d-flex flex-column col-12">
                        <div class="d-flex col-lg-12 justify-content-around my-2 flex-wrap">
                            <div class="col-lg-4 mx-1 my-2">
                                <CustomTextField
                                    control={control}
                                    header={"Full Name *"}
                                    name="Name"
                                    size="small"
                                    value={formik.values.firstName.trimStart()}
                                    placeholder={"Full Name"}
                                    inputProps={{
                                        min: 3,
                                        maxLength: 30, style: {
                                            height: "28px",
                                        }
                                    }}
                                    error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                    helperText={formik.touched.firstName ? formik.errors.firstName : ''}
                                    InputProps={{ sx: { borderRadius: "12px" } }}
                                    onChange={(e) => {
                                        const result = e.replace(/[0-9]/g, "");
                                        handleNameChange(e)
                                    }}
                                />
                            </div>
                            <div class="col-lg-4 mx-1 my-2">
                                <CustomTextField
                                    control={control}
                                    header={"Email *"}
                                    name="email"
                                    size="small"
                                    value={formik.values.email.trimStart()}
                                    placeholder={"Email"}
                                    inputProps={{
                                        min: 3,
                                        maxLength: 50, style: {
                                            height: "28px",
                                        }
                                    }}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email ? formik.errors.email : ''}
                                    InputProps={{ sx: { borderRadius: "12px" } }}
                                    onChange={(e) => {
                                        handleEmailChange(e)
                                    }}
                                />
                            </div>

                            <div class="col-lg-4 mx-1 my-2">
                            <div class="d-flex ">
                                <label class="mb-1 fw-normal">
                                    State *
                                </label>
                            </div>
                            <CustomDropdown data={statesData}
                                value={formik.values.state}
                                onChange={(e) => {
                                    handleStateChange(e)
                                }}
                                error={formik.touched.state && Boolean(formik.errors.state)}
                                helperText={formik.touched.state ? formik.errors.state : ''}
                                
                                name="state"
                                height={"44px"}
                                placeholder={"State"}
                            />
                        </div>

                            <div class="col-lg-4 mx-1 my-2">
                                <CustomTextField
                                    control={control}
                                    header={"Phone Number *"}
                                    type={"tel"}
                                    name="number"
                                    size="small"
                                    value={formik.values.phoneNumber}
                                    placeholder={"Phone Number"}
                                    inputProps={{
                                        min: 10,
                                        maxLength: 10, style: {
                                            height: "28px",
                                        }
                                    }}
                                    error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                                    helperText={formik.touched.phoneNumber ? formik.errors.phoneNumber : ''}
                                    InputProps={{ sx: { borderRadius: "12px" } }}
                                    onChange={(e) => {
                                        const result = e.replace(/[^0-9]/g, '');
                                        handlePincodeChange(result)
                                    }}
                                />
                            </div>

                            <div class="col-lg-10 mx-1 my-2">
                                <CustomTextField
                                    control={control}
                                    header={"Message *"}
                                    name="message"
                                    size="small"
                                    value={formik.values.message.trimStart()}
                                    placeholder={"Hello there,I would like to talk about how to..."}
                                    multiline={true}
                                    rows={5}
                                    inputProps={{
                                        min: 3,
                                        maxLength: 250,
                                    }}
                                    error={formik.touched.message && Boolean(formik.errors.message)}
                                    helperText={formik.touched.message ? formik.errors.message : ''}
                                    InputProps={{ sx: { borderRadius: "12px" } }}
                                    onChange={(e) => {
                                        const result = e.replace(/\D/g, "");
                                        // setMobileNumber(result);
                                        handleMessageChange(e)
                                    }}
                                />
                            </div>
                        </div>

                        <div class="align-self-center text-center">
                            <button type="submit" variant="contained" class={isFormFilled() ? "primaryButton" : "disabledButton"} >
                                Submit
                            </button>
                        </div>

                        <CustomModal 
                          close={closeSimpleModal}
                          open={simpleModal}
                          from={"SupportModal"}
                          Continue={handleContinueButton}
                          height={"370px"}
                     />


                    </div>
                </form>
            </div>

            <div class="col-lg-4 col-xl-3 d-flex flex-column justify-content-around">  
          <div class=" border border-white shadow rounded-4 d-flex flex-row justify-content-around bg-white mb-4 mb-md-0">
            <img src={phoneLogo} alt="phone" class="p-1"  />
            <div class="d-flex w-75 justify-content-start align-items-center">
            <p class="card-text  lg-w-0 text-left m-0  previewColor">+91 {supportData?.phone_number}</p>
            </div>
           
          </div>
          <div class=" border border-white shadow rounded-4 d-flex flex-row justify-content-around bg-white">
            <img src={mailLogo} alt="phone" class="p-1"  />
            {/* <p class="card-text w-75 text-left lg-w-0 mt-2 mx-md-2 previewColor">saasup@gmail.com</p> */}
            <div class="d-flex w-75 justify-content-start align-items-center">
            <a href="mailto:support@osangrows.com"  class="card-text  text-left  m-0  previewColor">{supportData?.email}</a>
            </div>
          </div>
          <div>
          <p class="mb-0"><b>Address:</b><br/><b>{supportData?.name}</b><br/>{supportData?.address}<br/>
           </p>
          
          </div>
        </div>
            </div>
           
            
        </div>
    )
}


export default Support